var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_-_mezza_LOG",
    "data-name": "Component - mezza LOG",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.75,
    height: 18,
    viewBox: "0 0 15.75 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M5.25,2A2.25,2.25,0,0,0,3,4.25V20l3.938-2.25L10.875,20l3.938-2.25L18.75,20V4.25A2.25,2.25,0,0,0,16.5,2Zm5.3,4.17A1.125,1.125,0,1,0,8.955,4.58L5.58,7.955a1.125,1.125,0,0,0,0,1.591L8.955,12.92a1.125,1.125,0,1,0,1.591-1.591L9.091,9.875h1.784A3.375,3.375,0,0,1,14.25,13.25v1.125a1.125,1.125,0,0,0,2.25,0V13.25a5.625,5.625,0,0,0-5.625-5.625H9.091Z",
    transform: "translate(-3 -2)",
    fill: "#5f6266",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.2b6f171ff4035052848377310acaee75.svg";
export { ForwardRef as ReactComponent };